import React, { Component } from "react";
import TransactionSummary from "./transactionSummary";
import TableContainer from "./table";
import { AUTHORIZATION_PENDING } from "../../../store/types";
import { connect } from "react-redux";
import { getTransactionData } from "../../../store/actions";

class TabContainer extends Component {
  constructor(props) {
    super(props);
    const { active } = this.props.location.state;
    this.state = {
      active: active || AUTHORIZATION_PENDING,
    };
  }

  componentDidMount() {
    this.props.getTransactionData({
      transflag: this.state.active,
      customfund: "189",
      Arn: this.props.token,
    });
  }

  onChangeActive = (active) => () => {
    this.setState({
      active,
    });
    this.props.getTransactionData({
      transflag: active,
      Arn: this.props.token,
      customfund: "189",
    });
  };

  render() {
    return (
      <div style={{ padding: 20 }}>
        <TransactionSummary
          active={this.state.active}
          onClick={this.onChangeActive}
        />
        <TableContainer active={this.state.active} />
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { token } = authReducer;
    return { token };
  },
  { getTransactionData }
)(TabContainer);
